import Autoplay from 'embla-carousel-autoplay';

export const createBannerAutoplayPlugin = () => {
  return Autoplay({
    delay: 3000,
    // stopOnInteraction: true,
    // stopOnMouseEnter: true,
    playOnInit: true,
  });
};

export const BANNER_AUTOPLAY_DELAY_MS = 3000;
